import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useReducer,
  useCallback,
} from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { useParams, useHistory } from "react-router-dom";
import { pdfjs, Document, Page, Outline } from "react-pdf";
import { Stage, Layer, Rect, Text, Group, Circle, Shape } from "react-konva";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import { mongoObjectId } from "../utils";
import { toast } from "react-toastify";
import Konva from "konva";
import clsx from "clsx";
// import { PDFDownloadLink, Document, Page } from '@react-pdf/renderer'
import {
  Button,
  ButtonDropdown,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { useQuery, useMutation } from "react-fetching-library";

import MainLayout from "../layouts/MainLayout";
// import 'react-pdf/dist/Page/AnnotationLayer.css';
import ContractConfigurationContainer from "../components/ContractConfiguration";
import ParticipantForm from "../components/ParticipantForm";

// Prueba
import TemplateCard from "../components/TemplateCard";

import PublicTemplatesListContainer from "../containers/PublicTemplatesList";
import TemplatesTableContainer from "../containers/TemplatesTable";
import { fetchTemplate, updateTemplate } from "../api/actions/templates";
import { fetchContract, saveContract } from "../api/actions/contracts";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function reducer(state, action) {
  switch (action.type) {
    case "document-loaded":
      return {
        ...state,
        status: "document-loaded",
        numPages: action.numPages,
        numPagesArr: new Array(state.numPages),
      };
    case "set-current-page":
      return {
        ...state,
        currentPage: action.currentPage,
      };
    case "increment-current-page":
      return {
        ...state,
        currentPage: state.currentPage + action.offset,
      };
    case "set-current-tab":
      return {
        ...state,
        currentTab: action.tabId,
      };
    case "set-template":
      return {
        ...state,
        template: action.template,
        participants: action.template.participants,
      };
    case "set-signatures":
      return {
        ...state,
        signatures: action.signatures,
      };
    case "update-signature":
      const participantSignatures = state.signatures[action.participantId];
      const newSignatures = participantSignatures.map((currentSign) => {
        if (currentSign._id === action.signature._id) {
          return action.signature;
        }
        return currentSign;
      });

      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.participantId]: newSignatures,
        },
      };
    case "add-signature":
      const participantSignatures2 = state.signatures[action.participantId];

      const newSignatures2 = [
        ...participantSignatures2,
        {
          _id: mongoObjectId(),
          left: 100,
          top: 300,
          width: 200,
          height: 100,
          page: state.currentPage,
        },
      ];
      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.participantId]: newSignatures2,
        },
      };
    case "remove-signature":
      const participantSignatures3 = state.signatures[action.participantId];

      const newSignatures3 = participantSignatures3.filter(
        (sign) => sign._id !== action.signatureId
      );

      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.participantId]: newSignatures3,
        },
      };
    case "update-participants":
      return {
        ...state,
        participants: state.participants.map((participant) => {
          return {
            ...participant,
            ...action.participants[participant._id],
          };
        }),
      };
    case "add-participant":
      const newId = mongoObjectId();
      const newParticipants = [
        ...state.participants,
        {
          _id: newId,
          obligation: "individual",
          name: "",
          last_name: "",
          representative: "",
          phone: "",
          email: "",
          label: `Participante ${(state.participants?.length ?? 0) + 1}`,
        },
      ];

      return {
        ...state,
        template: {
          ...state.template,
          participants: newParticipants,
        },
        participants: newParticipants,
        signatures: {
          ...state.signatures,
          [newId]: [],
        },
      };
    case "remove-participant":
      const filteredParticipants = state.participants.filter(
        (participant) => participant._id !== action.participantId
      );

      return {
        ...state,
        template: {
          ...state.template,
          participants: filteredParticipants,
        },
        participants: filteredParticipants,
        signatures: Object.fromEntries(
          Object.entries(state.signatures).filter(
            ([key, value]) => key !== action.participantId
          )
        ),
      };
    default:
      throw new Error();
  }
}

const initialState = {
  numPages: 1,
  numPagesArr: [],
  currentPage: 1,
  signatures: {},
  participants: [],
  template: {},
  status: "",
  currentTab: 1,
};

function getInitialFormState(template) {
  return {
    name: template.name,
    participants:
      template?.participants?.reduce((obj, participant) => {
        obj[participant._id] = participant;
        return obj;
      }, {}) ?? {},
  };
}

function PdfViewer() {
  const { t } = useTranslation("common");
  const { templateId, documentId } = useParams();
  const history = useHistory();
  const pageRef = useRef();
  const [state, dispatch] = useReducer(reducer, initialState);
  const fetchDocumentAction = useMemo(() => {
    if (documentId) {
      return fetchContract(documentId);
    }
    return fetchTemplate(templateId);
  }, [templateId, documentId]);
  const { payload, loading } = useQuery(fetchDocumentAction);
  const {
    payload: updatedTemplatePayload,
    mutate,
    loading: saving,
  } = useMutation(updateTemplate);
  const {
    payload: createContractPayload,
    mutate: saveContractMutation,
    loading: creating,
  } = useMutation(saveContract);
  // const signaturesPerPage = useMemo(() => {
  //   return payload?.data?.participants?.reduce((obj, participant) => {
  //     participant.signatures.map((signature) =>{
  //       if (!obj[signature.page]) obj[signature.page] = []
  //       obj[signature.page].push(participant.label)
  //     })
  //     return obj
  //   }, {}) ?? {}
  // }, [payload])
  const initialValues = useMemo(() => {
    return getInitialFormState(state.template);
  }, [state.template]);
  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      // const { participants } = state.template;
      // const { participants: formikParticipants, ...contract } = values;
      // const newParticipants = participants.map(participant => {
      //   return {
      //     ...participant,
      //     ...formikParticipants[participant._id],
      //     signatures: state.signatures[participant._id]
      //   }
      // })
      // await saveContractMutation({
      //   type: 'pdf',
      //   ...contract,
      //   participants: newParticioa
      // })
    },
    enableReinitialize: true,
  });

  const onDocumentLoadSuccess = ({ numPages }) => {
    dispatch({ type: "document-loaded", numPages });
  };

  useEffect(() => {
    if (payload?.success) {
      const template = payload.data;
      const signatures = template?.participants?.reduce((obj, participant) => {
        obj[participant._id] = participant.signatures;
        return obj;
      }, {});
      dispatch({ type: "set-template", template });
      dispatch({ type: "set-signatures", signatures });
    }
  }, [payload]);

  useEffect(() => {
    if (updatedTemplatePayload?.success) {
      toast.success("Los cambios se guardaron con éxito", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }, [updatedTemplatePayload]);

  useEffect(() => {
    if (formik.values?.participants) {
      dispatch({
        type: "update-participants",
        participants: formik.values?.participants,
      });
    }
  }, [formik.values]);

  const changeTab = (tabId) => () => {
    dispatch({ type: "set-current-tab", tabId });
  };

  const changePage = (offset) => {
    dispatch({ type: "increment-current-page", offset });
  };

  const nextPage = () => changePage(1);

  const previousPage = () => changePage(-1);

  const handleItemClick = ({ pageNumber }) => {
    dispatch({ type: "set-current-page", currentPage: pageNumber });
  };

  const goTo = (pageNumber) => () => {
    dispatch({ type: "set-current-page", currentPage: pageNumber });
  };

  const saveTemplate = async () => {
    const { participants } = state.template;
    const { participants: formikParticipants } = formik.values;
    const newParticipants = participants.map((participant) => {
      return {
        ...participant,
        ...formikParticipants[participant._id],
        signatures: state.signatures[participant._id],
      };
    });

    await mutate({ templateId, participants: newParticipants });
  };

  console.log({ state });

  const handleDragStart = useCallback((e) => {
    e.target.setAttrs({
      shadowOffset: {
        x: 15,
        y: 15,
      },
      scaleX: 1,
      scaleY: 1,
    });
  }, []);

  const handleDragEnd = (e) => {
    const signature = {
      _id: e.target.attrs.id,
      left: e.target.attrs.x,
      top: e.target.attrs.y,
      width: 595,
      height: 842,
      page: state.currentPage,
    };

    dispatch({
      type: "update-signature",
      participantId: e.target.attrs.participantId,
      signature,
    });

    e.target.to({
      duration: 0.5,
      easing: Konva.Easings.ElasticEaseOut,
      scaleX: 1,
      scaleY: 1,
      shadowOffsetX: 5,
      shadowOffsetY: 5,
    });
  };

  const handleDragBound = (pos, event) => {
    const height = 842;
    const width = 595;
    const newY = pos.y < 15 ? 15 : pos.y > height - 104 ? height - 104 : pos.y;
    const newX = pos.x < 1 ? 1 : pos.x > width - 205 ? width - 205 : pos.x;

    return {
      x: newX,
      y: newY,
    };
  };

  const addSignature = (participant) => () => {
    dispatch({ type: "add-signature", participantId: participant._id });
  };

  const removeSignature = (e) => {
    const signatureId = e.target.attrs.signatureId;
    const participantId = e.target.attrs.participantId;
    dispatch({ type: "remove-signature", participantId, signatureId });
  };

  const addParticipant = () => {
    dispatch({ type: "add-participant" });
  };
  const removeParticipant = (participantId) => () => {
    dispatch({ type: "remove-participant", participantId });
  };

  const goToCreateContract = () => {
    history.push(`/templates/${templateId}/documents/create`);
  };

  return (
    <MainLayout showUpgradeBanner={false}>
      <div className="d-flex">
        <div className="container mb-5">
          <Row>
            <Col lg={8}>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between mb-3">
                  <p className="font-weight-bold mb-0">{state.template.name}</p>
                  <div className="">
                    <Button
                      className="mr-2"
                      color="light"
                      size="sm"
                      onClick={documentId ? formik.handleSubmit : saveTemplate}
                    >
                      {documentId ? "Enviar" : "Guardar"}
                    </Button>{" "}
                    {/**<FontAwesomeIcon icon='save' /> */}
                    {/* <Button className="mr-2" color="accent" size="sm"  onClick={goToCreateContract}>Crear Contrato</Button> */}
                    <UncontrolledButtonDropdown
                      direction="down"
                      style={{ zIndex: 10000 }}
                    >
                      <DropdownToggle caret color="accent-100" size="sm">
                        Agregar firmas
                      </DropdownToggle>
                      <DropdownMenu>
                        {state.participants?.map((participant, i) => (
                          <React.Fragment key={participant._id}>
                            {i !== 0 && <DropdownItem divider />}
                            <DropdownItem onClick={addSignature(participant)}>
                              {participant.label}
                            </DropdownItem>
                          </React.Fragment>
                        ))}
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  </div>
                </div>
                {/* <p>Page {state.currentPage} of {state.numPages}</p> */}
              </div>
              <div className="document-container p-2 mt-3 d-flex flex-column align-items-center">
                <Stage width={595} height={842} className="layer" id="layer">
                  <Layer>
                    {state.status === "document-loaded" &&
                      state.participants?.map((participant) =>
                        state.signatures[participant._id]?.map(
                          (signature, i) => {
                            if (signature.page !== state.currentPage) {
                              return null;
                            }

                            return (
                              signature.page === state.currentPage && (
                                <Group
                                  key={i}
                                  x={signature.left}
                                  y={signature.top}
                                  id={signature._id}
                                  width={signature.width}
                                  height={signature.height}
                                  participantId={participant._id}
                                  draggable
                                  onDragStart={handleDragStart}
                                  onDragEnd={handleDragEnd}
                                  dragBoundFunc={handleDragBound}
                                >
                                  <Text
                                    fontSize={18}
                                    offsetY={-100 / 2.5}
                                    width={200}
                                    height={100}
                                    text={`Área de firma \n ${participant.label}`}
                                    align="center"
                                  />
                                  <Rect
                                    width={200}
                                    height={100}
                                    fill="black"
                                    opacity={0.3}
                                    shadowEnabled={false}
                                  />
                                  <Circle
                                    participantId={participant._id}
                                    onClick={removeSignature}
                                    signatureId={signature._id}
                                    x={200}
                                    fill="red"
                                    radius={7}
                                  />
                                </Group>
                              )
                            );
                          }
                        )
                      )}
                  </Layer>
                </Stage>
                <div
                  className="custom-pdf"
                  style={{
                    top: `-${842}px`,
                    width: `595px`,
                    marginBottom: `-${842}px`,
                  }}
                >
                  <Document
                    file={state.template?.importedPdf}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onItemClick={handleItemClick}
                    options={{
                      cMapUrl: `cmaps/`,
                      cMapPacked: true,
                      standardFontDataUrl: "standard_fonts/",
                    }}

                    // loading={
                    //   <Text text="Loading PDF..." />
                    // }
                  >
                    {/* <Outline /> */}
                    <Page
                      pageNumber={state.currentPage}
                      inputRef={(ref) => (pageRef.current = ref)}
                      width={595}
                    />
                  </Document>
                  {/* <div className="d-flex justify-content-between">
                              <Button onClick={previousPage} disabled={state.currentPage <= 1}>Anterior</Button>
                              <Button onClick={nextPage} disabled={state.currentPage >= state.numPages}>Siguiente</Button>
                            </div> */}
                </div>
              </div>
            </Col>
            <Col lg={4} className=" ">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={clsx(state.currentTab === 1 && "active")}
                    onClick={changeTab(1)}
                  >
                    {t("index")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={clsx(state.currentTab === 2 && "active")}
                    onClick={changeTab(2)}
                  >
                    {t("participant", { count: 2 })}
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent
                activeTab={state.currentTab}
                className="bg-light pb-2 border-right border-bottom border-left"
              >
                <TabPane
                  tabId={1}
                  className={clsx(
                    "vh-100 align-self-center justify-content-center overflow-auto",
                    state.currentTab === 1 && "d-flex "
                  )}
                >
                  <PDFIndex
                    url={state.template?.importedPdf}
                    onDocumentLoadSuccess={onDocumentLoadSuccess}
                    onItemClick={handleItemClick}
                    numPagesArr={state.numPagesArr}
                    goTo={goTo}
                  />
                </TabPane>
                <TabPane
                  tabId={2}
                  style={{
                    maxHeight: "990px",
                    minHeight: "990px",
                    overflow: "scroll",
                  }}
                >
                  <Button
                    className="mx-3 mt-4"
                    size="sm"
                    color="accent"
                    onClick={addParticipant}
                  >
                    Agregar participante
                  </Button>
                  {state.participants.map((participant) => (
                    <ParticipantForm
                      loading={loading}
                      key={participant._id}
                      name={`participants.${participant._id}`}
                      onChange={formik.handleChange}
                      showFillMyData={false}
                      participant={formik.values.participants[participant._id]}
                      onRemove={removeParticipant}
                    />
                  ))}
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </div>
      </div>

      {/* Prueba */}
    </MainLayout>
  );
}

export default PdfViewer;

// adapted from https://github.com/tajo/react-portal/blob/55ed77ab823b03d1d4c45b950ba26ea5d687e85c/src/LegacyPortal.js

export function PDFIndex({
  url,
  numPagesArr,
  onDocumentLoadSuccess,
  onItemClick,
  goTo,
}) {
  return (
    <Document
      file={url}
      onLoadSuccess={onDocumentLoadSuccess}
      style={{
        width: "200px",
        boxShadow: "0px 0px 14px 3px rgba(0,0,0,0.75)",
      }}
      onItemClick={onItemClick}
    >
      {Array.from(numPagesArr, (el, index) => (
        <div key={el} onClick={goTo(index + 1)}>
          {" "}
          {/* className="row flex-row align-items-center" */}
          {/* <div className="col-2">
                      {
                      signaturesPerPage[index + 1]?.map(participant => (
                          <div>
                          {participant.charAt(0)} 
                          </div>
                      ))
                      }
                  </div> */}
          {/* <div className="col-10"> */}
          <div style={{ boxShadow: "0px 0px 14px 3px rgba(0,0,0,0.05)" }}>
            <Page
              className="my-3"
              key={`page_${index + 1}`}
              width={200}
              pageNumber={index + 1}
            />
          </div>
          <small className="d-flex justify-content-center">{index + 1}</small>
          {/* </div> */}
        </div>
      ))}
    </Document>
  );
}
class Portal extends React.Component {
  componentDidMount() {
    this.renderPortal();
  }

  componentDidUpdate(props) {
    this.renderPortal();
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.defaultNode || this.props.node);
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }
    this.defaultNode = null;
  }

  renderPortal(props) {
    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement("div");
      document.body.appendChild(this.defaultNode);
    }

    let children = this.props.children;
    // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
    if (typeof children.type === "function") {
      children = React.cloneElement(children);
    }

    ReactDOM.render(children, this.props.node || this.defaultNode);
  }

  render() {
    return null;
  }
}
